"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.foundation_layout = void 0;
const global_1 = require("../size/global");
exports.foundation_layout = {
    breakpoint: {
        idl_layout_breakpoint_xs: global_1.foundation_size.screen.size_screen_320,
        idl_layout_breakpoint_sm: global_1.foundation_size.screen.size_screen_768,
        idl_layout_breakpoint_md: global_1.foundation_size.screen.size_screen_1024,
        idl_layout_breakpoint_lg: global_1.foundation_size.screen.size_screen_1280,
        idl_layout_breakpoint_xl: global_1.foundation_size.screen.size_screen_1600,
    },
    container: {
        idl_layout_container_xs: global_1.foundation_size.screen.size_screen_768,
        idl_layout_container_sm: global_1.foundation_size.screen.size_screen_1024,
        idl_layout_container_md: global_1.foundation_size.screen.size_screen_1024,
        idl_layout_container_lg: global_1.foundation_size.screen.size_screen_1280,
        idl_layout_container_xl: global_1.foundation_size.screen.size_screen_1600,
    },
    columns: {
        idl_layout_columns_xs: global_1.foundation_size.tiny.size_tiny_4,
        idl_layout_columns_sm: global_1.foundation_size.tiny.size_tiny_8,
        idl_layout_columns_md: global_1.foundation_size.small.size_small_12,
        idl_layout_columns_lg: global_1.foundation_size.small.size_small_12,
        idl_layout_columns_xl: global_1.foundation_size.small.size_small_12,
    },
};
//# sourceMappingURL=global.js.map